<template>
	<div v-if="inputRecordFormVisible" style="width: 100%">
		<el-form :inline="true" :model="formInline" class="user-search">
			<el-form-item style="float: right; margin-right: 0">
				<el-button size="small" type="primary" class="el-icon-search" @click="inputChange()">搜索</el-button>
				<el-button size="small" icon="el-icon-refresh" @click="clearAll">重置</el-button>
			</el-form-item>
		</el-form>
		<STable :columns="columnsData" :data="listData" :loading="loading" border @get-data="getListData"></STable>
		<!-- 分页组件 -->
		<Pagination v-if="pageShow" :child-msg="pageparm" @call-father="callFather"></Pagination>
	</div>
</template>

<script>
import { GetWareHouseHistoryList } from "@/api/storeOrderApi.js";
export default {
	data() {
		return {
			inputRecordFormVisible: false,
			pageShow: true,
			loading: false, // 显示加载
			listData: [],
			// 分页参数
			pageparm: {
				pageIndex: 1,
				pageSize: 10,
				total: 0
			},
			formInline: {
				pageIndex: 1,
				pageSize: 10,
				searchKey: ""
			},
			columnsData: [], //显示列
			listColumns: [
				{
					prop: "rowNumber",
					label: "序号",
					align: "center",
					width: "80",
					isKeep: true
				},
				{
					prop: "yuanQuantity",
					label: "原数量",
					align: "center"
				},
				{
					prop: "xianQuantity",
					label: "修改后数量",
					align: "center"
				},
				{
					prop: "creator",
					label: "操作人",
					align: "center"
				},
				{
					prop: "createTime",
					label: "操作时间",
					align: "center"
				}
			]
		};
	},
	// 注册组件
	components: {},
	created() {
		// 初始列
		this.getCheckBox(this.listColumns.map((item) => item.label));
	},
	computed: {},
	methods: {
		// 获取筛选框
		getCheckBox(val) {
			let arr = this.listColumns.filter((v) => !val.includes(v.label));
			this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
		},
		// 显示弹窗
		showUpdateQtyRecordDialog(keyId) {
			this.inputRecordFormVisible = true;
			this.formInline.searchKey = keyId;
			this.search();
		},
		// 关闭弹窗
		closeUpdateQtyRecordDialog() {
			this.inputRecordFormVisible = false;
		},
		changePages() {},
		// 获取列表
		getListData() {
			this.loading = true;
			GetWareHouseHistoryList(this.formInline)
				.then((res) => {
					if (res.code == 1) {
						this.listData = res.data;
						this.pageparm.total = res.totalNumber;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				})
				.finally(() => {
					this.loading = false;
				});
		},
		// 重置
		clearAll() {
			this.$data.formInline = this.$options.data.call(this).formInline;
			this.search();
		},
		inputChange(val) {
			this.search();
		},
		// 分页插件事件
		callFather(parm) {
			if (parm.currentPage == undefined) {
				this.formInline.pageIndex = 1;
			} else {
				this.formInline.pageIndex = parm.currentPage;
			}
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		},
		// 搜索事件
		search() {
			this.formInline.pageIndex = 1;
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.getListData();
		}
	}
};
</script>

<style scoped>
.one_1 {
	padding: 2px 20px;
	background: #e6f7ff;
	border: 1px solid #6acaf3;
	color: #56bbfd;
	border-radius: 2px;
}

.one_2 {
	padding: 2px 20px;
	background: #fcd4ff;
	border: 1px solid #dfbce2;
	color: #ea7cff;
	border-radius: 2px;
}
</style>
